import React, { FC } from 'react';
import styled from 'styled-components';
// import { Container } from '../components/Forbidden/styles';
const Wrap = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  min-height: 100vh;
  background: #020024;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(rgba(33, 78, 169, 0.8)),
    color-stop(35%, rgba(18, 115, 218, 0.85)),
    to(rgba(33, 78, 169, 0.8))
  );
  background: linear-gradient(
    90deg,
    rgba(33, 78, 169, 0.8) 0%,
    rgba(18, 115, 218, 0.85) 35%,
    rgba(33, 78, 169, 0.8) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#214ca8",endColorstr="#1273da",GradientType=1);
  cursor: default;
`;
const Container = styled.div`
  position: relative;
  height: 100vh;
`;
const Notice = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 24px;
  line-height: 40px;
  color: #fff;
  word-break: keep-all;
`;
const Title = styled.h1`
  font-size: 35px;
  font-weight: 900;
  margin-top: 20px;
`;
const P = styled.p`
  margin: 0 0 1.2rem;
  text-align: center;
`;

const SceneTemporary: FC = () => {
  return (
    <div className="bg5">
      <Wrap>
        <Container>
          <Notice>
            <i className="icon icon-4x icon-stop" />
            <Title>Service is temporarily unavailable.</Title>
            <P>
              Please try again later.
              <br />
              Sorry for inconvenience.
            </P>
          </Notice>
        </Container>
      </Wrap>
    </div>
  );
};

export default SceneTemporary;
